// extracted by mini-css-extract-plugin
export default {"page":"docsPage_page__b8zpD","layout":"docsPage_layout__bMrB7","main":"docsPage_main__BSIAS","contentWrapper":"docsPage_contentWrapper__aFmS8","notFound":"docsPage_notFound__MSyax"};